<template>
  <div class="container-fluid">
  <Navbar></navbar>
    <img src="../assets/logo.png">
    <h1 v-if="show">{{ msg }}</h1>
    <h2 v-if="show">Essential Links</h2>
    <ul class="list-group">
      <li><router-link to="/login">Login</router-link></li>
      <li><router-link to="/register">Register</router-link></li>
    </ul>
  </div>
</template>

<script>
import Navbar from './global/TopFixedNavbar'

export default {
  name: 'Index',
  data () {
    return {
      show: false,
      msg: 'Welcome to Your Vue.js App Start Stuff'
    }
  },
  components: {
    Navbar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
color:red
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue